<template>
    <div>
    <page-title-bar></page-title-bar>

<v-container fluid pt-0 grid-list-xl>


        <app-card>
				<v-btn color="default" @click="cancel" name="btncancel" >Terug</v-btn>
                <v-btn color="success" @click="btnSave" name="btnsave" class="text-xs-right" :disabled="disable">Opslaan</v-btn>
			</app-card>

<v-layout row wrap>
            	<app-card 
						heading="Pakket info"
						colClasses="xl6 lg6 md6 sm12 xs12"
						customClasses="mb-0">
     <v-layout row>
        <v-flex sm12>
        Pakket omschrijving
        <dx-text-box v-model="currentRec.Descr" placeholder="Omschrijving pakket..."></dx-text-box>
        </v-flex>
    </v-layout>
    <v-layout row><v-flex sm12>&nbsp;</v-flex></v-layout>
   
    
     <v-layout row>
      <v-flex sm12>
        Behandeling 1
        <dx-select-box placeholder="Kies behandeling" :data-source="dataSourceServLst" ref="cmbArtLst"
           value-expr="ArticleID" 
           display-expr="Title"
           v-model="currentRec.Art1"
           :show-clear-button="true"
           ></dx-select-box>
        </v-flex>
    </v-layout>

    
     <v-layout row>
      <v-flex sm12>
        Behandeling 2
        <dx-select-box placeholder="Kies behandeling" :data-source="dataSourceServLst" ref="cmbArtLst"
           value-expr="ArticleID" 
           display-expr="Title"
           v-model="currentRec.Art2"
           :show-clear-button="true"
           ></dx-select-box>
        </v-flex>
    </v-layout>

     <v-layout row>
      <v-flex sm12>
        Behandeling 3
        <dx-select-box placeholder="Kies behandeling" :data-source="dataSourceServLst" ref="cmbArtLst"
           value-expr="ArticleID" 
           display-expr="Title"
           v-model="currentRec.Art3"
           :show-clear-button="true"
           ></dx-select-box>
        </v-flex>
    </v-layout>

     <v-layout row>
      <v-flex sm12>
        Behandeling 4
        <dx-select-box placeholder="Kies behandeling" :data-source="dataSourceServLst" ref="cmbArtLst"
           value-expr="ArticleID" 
           display-expr="Title"
           v-model="currentRec.Art4"
           :show-clear-button="true"
           ></dx-select-box>
        </v-flex>
    </v-layout>

     <v-layout row>
      <v-flex sm12>
        Behandeling 5
        <dx-select-box placeholder="Kies behandeling" :data-source="dataSourceServLst" ref="cmbArtLst"
           value-expr="ArticleID" 
           display-expr="Title"
           v-model="currentRec.Art5"
           :show-clear-button="true"
           ></dx-select-box>
        </v-flex>
    </v-layout>

    
    <v-layout row><v-flex sm12>&nbsp;</v-flex></v-layout>


            	</app-card>
</v-layout>
</v-container>

    </div>
</template>

<script>

import myHttpApi from "../../api/myHttpApi";
import { DxButton, DxTextBox, DxSelectBox, DxPopup } from 'devextreme-vue';
import { confirm } from 'devextreme/ui/dialog';
import router from '../../router';

export default {
  components: {
    DxButton,
    DxTextBox,
    DxSelectBox,
    DxPopup 
  },
  props: {
    id : {type : String}
  },
  data() {
 
    return {
        dataSourceServLst : [],
        popupModify : false,
        txtPackage : '',
        artValue1 : {},
        artValue2 : {},
        artValue3 : {},
        artValue4 : {},
        artValue5 : {},
        currentRec : {},
        disable : false
    };
  },
   mounted() {
    //this.getRemoteData();
    this.getServicesRemoteData();
    //this.artValue1 = 'b601af5f-0803-4873-b36a-7a43098a57b3';
  },
  computed: {
  },
  methods: {
    cancel ()  {
        router.go (-1);
    },
    onDeleteClicked (item) {
       let result = confirm("Record <strong>" + item.row.data.Descr + "</strong> verwijderen.<br><br><i>Ben je zeker?</i>", "Record verwijderen");
            result.then((dialogResult) => {
                //alert(dialogResult ? "Confirmed" : "Canceled");
                if (dialogResult == true)
                {
                   myHttpApi.post('BOSettings/DelArtOnline', item.row.data)
                    .then(response => {
                     
                    })
                    .catch(error => {
                      console.log(error);
                    });
                }
            });
    },
    getServicesRemoteData() {

	  myHttpApi
      this.dataSourceServLst = [];

      myHttpApi.post('BOSettings/GetServicesAndPackages', "")
          .then(response => {
              this.dataSourceServLst = response.data;
              this.getRemotePackage();
          })
          .catch(error => {
            console.log(error);
          });
    },
    getRemotePackage() {
      
      myHttpApi
     
      const searchRec = {Search: this.id, Extra: ""}

      myHttpApi.post('BOSettings/GetPackage', searchRec)
          .then(response => {
              this.currentRec = response.data;
              this.artValue1 = this.currentRec.artValue1;
              this.artValue2 = this.currentRec.artValue2;
              this.artValue3 = this.currentRec.artValue3;
              this.artValue4 = this.currentRec.artValue4;
              this.artValue5 = this.currentRec.artValue5;
          })
          .catch(error => {
            console.log(error);
          });
    },
    btnSave () {

       //console.log (this.artValue2);
       this.disable = true;

        myHttpApi.post('BOSettings/SavePackage', this.currentRec)
          .then(response => {
             this.disable = true;
          })
          .catch(error => {
            console.log(error);
          });
    },
  }
};
</script>